import React from "react";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import ContactDetailForm from "./contact-detail-form/contact-detail-form";
import RetentionConsentSection from "./data-retention-consent-section/retention-consent-section";
import ContactDetilasPrivacyPolicyDescription from "./policy-description/policy-description";
import ContactdetilasPreferenceSection from "./preferences-section/preferences-section";
import ContactdetilasTitle from "./title/title";

function ContactDetailsFormSection() {
  const { current } = useWizard();

  const getRetentionConsent = current?.brandSpecificParams?.getRetentionConsent;
  const isDisplayTopPrivacyPolicySection =
    current?.brandSpecificParams?.displayTopPrivacyPolicySection;
  return (
    <div className="w-full flex justify-center">
      <div className="lg:w-[414px] md:w-[400px] w-full ">
        <ContactdetilasTitle />
        {isDisplayTopPrivacyPolicySection && (
          <ContactDetilasPrivacyPolicyDescription />
        )}
        <ContactDetailForm />
        <ContactdetilasPreferenceSection />
        {getRetentionConsent && <RetentionConsentSection />}
      </div>
    </div>
  );
}

export default ContactDetailsFormSection;
